module.exports = __webpack_public_path__ + "static/media/10.11e87619.mp3";